import React from 'react';
import PropTypes from 'prop-types';

const QuoteAction = (props) => {
  const {
    onClick,
    label,
    icon,
    disabled,
    href,
  } = props;

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
    if (href && !onClick) {
      // eslint-disable-next-line no-undef
      window.open(href);
    }
  };

  return (
    <button
      type="button"
      className="quote-action"
      disabled={disabled}
      onClick={handleClick}>
      <img src={icon} alt={label} className="mr-2" />
      {label}
    </button>
  );
};

QuoteAction.defaultProps = {
  onClick: null,
  label: '',
  icon: null,
  disabled: false,
  href: null,
};

QuoteAction.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
};

export default QuoteAction;
